export enum GroupDivision {
    NaoRegistrado = 0,
    Omnik = 1
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/GroupDivision.ts